import downloadjs from "downloadjs";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { customHistory } from "../../framework/customHistory";
import * as messageService from "../../models/services/messageService";
import * as attachmentService from "../../models/services/attachmentService";
import { Translations } from "ui/Scripts/source/models/translations";
import { AttachmentSummaryList } from "../attachment/attachmentSummaryList";
import { RouteComponentProps } from "react-router";
import { EditPageHeader } from "../app/header";
import { IMessageEditItem } from "../../models/message/messageEditItem";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { Footer } from "../app/footer";
import { ConfirmationDialogResult, ReadReceiptCategory } from "ui/Scripts/source/models/enums";
import { AppUtils } from "source/framework/appUtils";
import { ConfirmationDialogType } from "../../models/store/storeTypes";

//MessageEdit
export interface IMessageEditOwnProps {
}

export interface IMessageEditStateProps {
    item: IMessageEditItem;
    attachments: IFileAttachment[];
    returnUrl: string;
}

export interface IMessageEditDispatchProps {
    loadMessage: (id: string) => void;
    resetMessage: () => void;
}

export interface IMessageEditPathProps {
    messageId: string;
}

type MessageEditProp = IMessageEditOwnProps & IMessageEditStateProps & IMessageEditDispatchProps & RouteComponentProps<IMessageEditPathProps>;

interface IMessageEditState {
    id: string;
    requiresReceiptIsRead: boolean;
    requiresReceipt: boolean;
    isRead: boolean;
}

export class MessageEdit extends React.Component<MessageEditProp, IMessageEditState> {
    constructor(props: MessageEditProp) {
        super(props);
        this.state = {
            id: !Base.isNullOrUndefined(props.item) ? props.item.id : null,
            requiresReceiptIsRead: props.item && props.item.requiresReceiptIsRead,
            requiresReceipt: props.item && props.item.requiresReceipt,
            isRead: props.item && props.item.isRead,
        };
    }

    componentDidMount(): void {
        this.props.loadMessage(this.props.match.params.messageId);
    }

    static getDerivedStateFromProps(nextProps: MessageEditProp, prevState: IMessageEditState): IMessageEditState {
        if (nextProps.item && nextProps.item.id !== prevState.id) {
            return {
                id: nextProps.item.id,
                requiresReceiptIsRead: nextProps.item.requiresReceiptIsRead,
                requiresReceipt: nextProps.item.requiresReceipt,
                isRead: nextProps.item.isRead
            };
        } else {
            return null;
        }
    }

    componentWillUnmount(): void {
        this.props.resetMessage();
    }

    handleBackClick = () => {
        customHistory.push("/message");
    };

    sendMessageReadReceipt = async (category: ReadReceiptCategory) => {
        const item = this.props.item;
        if (!item) return;
        const result = AppUtils.callService(() => messageService.sendMessageReadReceipt(item.id, item.companyId, category), false);
        if (!result) return;
        if (category === ReadReceiptCategory.Automatic) return;
        this.setState({
            requiresReceiptIsRead: true
        });
    };

    componentDidUpdate(prevProps: MessageEditProp, _prevState: IMessageEditState, _snapshot: any): void {
        if (!prevProps.item && this.props.item) {
            if (!this.state.isRead) {
                this.sendMessageReadReceipt(ReadReceiptCategory.Automatic);
            }
        }
    }

    handleAttachmentDownload = async (id: string) => {
        if (!id) return;
        const attachment = this.props.attachments.find(i => i.id === id);
        if (!attachment) return;
        if (attachment.file) {
            downloadjs(attachment.file, attachment.name);
            return;
        }
        if (attachment.isNew()) return;
        const fileName = await AppUtils.callService(() => attachmentService.getAttachment(id));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, fileName));
    };

    handleSendReadReceipt = async () => {
        const result = await AppUtils.showConfirmationDialog(Translations.SendReadReceiptConfirmation, false, ConfirmationDialogType.Information, Translations.SendReadReceipt);
        if (result !== ConfirmationDialogResult.Yes) return;
        this.sendMessageReadReceipt(ReadReceiptCategory.ManualRequest);
    };

    render() {
        const props = this.props;
        const state = this.state;
        const item = props.item;
        if (item == null) {
            return (
                <div className="pageBackground" style={ { zIndex: 2 } }>
                    <EditPageHeader
                        title={Translations.CurrentTopics}
                        onBackClick={this.handleBackClick}
                    />
                </div>
            );
        }
        return (
            <div className="pageBackground" style={ { zIndex: 2 } }>
                <EditPageHeader
                    title={Translations.CurrentTopics + " - " + item.title}
                    onBackClick={this.handleBackClick}
                />
                <Footer
                    isReadOnly={!state.requiresReceipt || state.requiresReceiptIsRead}
                    buttonClass="check mui"
                    buttonTitle={Translations.SendReadReceipt}
                    onClick={this.handleSendReadReceipt}
                />
                <div className="pageContentContainer mainEdit messageEdit">
                    <div className="dataContainer">
                        {state.requiresReceipt && !state.requiresReceiptIsRead &&
                            <div className="row">
                                <div className="alert alert-info messageInfo" role="alert" dangerouslySetInnerHTML={ { __html: Translations.SendReadReceiptInfo } } />
                            </div>
                        }
                        <div className="row messageTitle">
                            <div className="col col-12">
                                <div className="iconCont">
                                    <AvatarImage
                                        name={item.userName}
                                        image={item.userPicture}
                                    />
                                </div>
                                <div className="dateCont ra">{Base.timeToDateStr(item.date)}</div>
                                <span className="dataCont">
                                    <label className="control-label">{item.title}</label>
                                    <span className="publisher">{(!Base.isNullOrEmpty(item.userCompanyName) ? item.userCompanyName + " / " : "") + item.userName}</span>
                                </span>
                            </div>
                        </div>
                        <div className="row messageContent">
                            <div className="col col-12" dangerouslySetInnerHTML={ { __html: item.content } } />
                        </div>
                        {props.attachments.length > 0 &&
                            <div className="row messageAttachments">
                                <div className="col-12">
                                    <label className="control-label">{Translations.Attachments}</label>
                                    <AttachmentSummaryList
                                        lateThreshold={null}
                                        attachments={props.attachments}
                                        onDownloadAttachment={this.handleAttachmentDownload}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}